// extracted by mini-css-extract-plugin
module.exports = {"tenantAuthen":"TenantAuthen_tenantAuthen__2o0UU","buttonArea":"TenantAuthen_buttonArea__3gJuz"};